import ProductFamily from 'umg-ember-backend/components/record-explorer/for/product-family';

<template>
  <ProductFamily @records={{@model}} @recordType='product-family' />
</template>
